// --- Core ---
import {FC} from "react";
import {FieldRenderProps} from "react-final-form";
// --- MUI ---
import {TimePicker} from "@mui/x-date-pickers";

interface TimeFieldProps {
  required?: boolean;
}

/**
 * The final form compatible wrapper around MUI TimePicker component
 */
export const TimeField: FC<FieldRenderProps<Date> & TimeFieldProps> = ({input, meta: {invalid, error, touched}, required, ...custom}) => (
  <TimePicker
    slotProps={
      {
        textField: {
          error: touched && invalid,
          fullWidth: true,
          helperText: touched && error,
          variant: "outlined",
          required,
          onFocus: input.onFocus,
          onBlur: input.onBlur
        }
      }
    }
    {...input}
    {...custom}
  />
);
